// ellipsis.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'ellipsis',
  standalone: true,
})
export class EllipsisPipe implements PipeTransform {
  private defaultMaxLength: number = 10;

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined, maxLength: number = this.defaultMaxLength): string {
    const text = value ?? '';
    const truncatedValue = text.length > maxLength ? text.substring(0, maxLength) + ' ...' : text;

    return `<span title="${text}">${truncatedValue}</span>`;
  }
}
